import { OneClickFromCrmStatus } from '@/campaign-action-shared/store/one-click-from-crm-statuses'

export default function buildState(componentName, defaultState) {
  const el = document.querySelector(`.vue-component-loader[data-component-name=${componentName}]`)
  const { ...initialState } = JSON.parse(el.dataset.storeData)

  const state = {...defaultState, ...initialState}

  if (state.tryOneClickFromCrm) {
    state.oneClickFromCrmStatus = OneClickFromCrmStatus.PENDING
  } else {
    state.oneClickFromCrmStatus = OneClickFromCrmStatus.NOT_AVAILABLE
  }

  return state
}
